import { EnvSchema } from '#core/schema/EnvSchema.ts';

// TODO: https://github.com/alexmarqs/zod-config
export const env = EnvSchema.parse({
  baseUrl: import.meta.env.VITE_BASE_URL,
  strictMode: import.meta.env.VITE_IS_STRICT_MODE === 'true',
  basePath: import.meta.env.VITE_APP_BASE_PATH,
  displayTz: import.meta.env.VITE_APP_DISPLAY_TZ,
  appName: import.meta.env.VITE_APP_NAME,
  auth: {
    clientId: import.meta.env.VITE_APP_CLIENT_ID,
    tenantId: import.meta.env.VITE_APP_TENANT_ID,
    cluster: import.meta.env.VITE_APP_CLUSTER,
    project: import.meta.env.VITE_APP_PROJECT,
    redirectUri: import.meta.env.VITE_APP_REDIRECT_URI,
  },
  cdf: { url: import.meta.env.VITE_APP_CDF_URL },
});
